import { callApi } from "../../utils/common.utils";


export const fetchBenchmarkContact = async (userId: string | null) => {
  const payLoad = {
    accountManagerID: userId,
  };
  return callApi("getBenchmarkContact", payLoad, "getData");
};

export const fetchBenchmarkOrganisation = async (constId: number) => {
  const payLoad = {
    id: constId,
  };
  return callApi("getBenchmarkOrganization", payLoad, "getData");
};

export const fetchBenchmarkCustomerContactList = async (
  userId: string | null
) => {
  const payLoad = {
    id: userId,
  };
  return callApi("getCustomerContact", payLoad, "getData");
};

// Commented, in case if needed in future
// export const fetchBenchmarkInstallationList = async (userId: string | null) => {
//   const payLoad = {
//     id: userId,
//   };
//   return callApi("getInstallationPricing", payLoad, "getData");
// };

export const fetchBenchmarkSingleContact = async (userId: number) => {
  const payLoad = {
    contact_id: userId,
  };
  return callApi("getContact", payLoad, "getData");
};

export const updateBenchmarkSingleContact = async (
  userId: number | null,
  firstName: string,
  lastName: string,
  jobTitle: string,
  phoneOffice: string,
  phoneMobile: string,
  phoneOther: string,
  emailOffice: string,
  isPrimary: boolean,
  isBilling: boolean
) => {
  const payLoad = {
    id: userId,
    firstname: firstName,
    lastname: lastName,
    jobtitle: jobTitle,
    phoneoffice: phoneOffice,
    phonemobile: phoneMobile,
    phoneother: phoneOther,
    emailoffice: emailOffice,
    Change_PrimaryContact: isPrimary ? 1 : 0,
    Change_BillingContact: isBilling ? 1 : 0,
  };
  return callApi("addNewContact", payLoad, "addData");
};

export const addBenchmarkSingleContact = async (
  orgId: string | null,
  firstName: string,
  lastName: string,
  jobTitle: string,
  phoneOffice: string,
  phoneMobile: string,
  phoneOther: string,
  emailOffice: string,
  isPrimary: boolean,
  isBilling: boolean
) => {
  const payLoad = {
    orgid: orgId,
    firstname: firstName,
    lastname: lastName,
    jobtitle: jobTitle,
    phoneoffice: phoneOffice,
    phonemobile: phoneMobile,
    phoneother: phoneOther,
    emailoffice: emailOffice,
    Change_PrimaryContact: isPrimary ? 1 : 0,
    Change_BillingContact: isBilling ? 1 : 0,
  };
  return callApi("addNewContact", payLoad, "addData");
};

export const deleteBenchmarkSingleContact = async (userId: number) => {
  const payLoad = {
    id: userId,
  };
  return callApi("deleteContact", payLoad, "deleteData");
};
